export const getObjectKeys = (obj) => Object.keys(obj);
